import { render, staticRenderFns } from "./create-v2.vue?vue&type=template&id=4e82523f&scoped=true"
import script from "./create-v2.vue?vue&type=script&lang=js"
export * from "./create-v2.vue?vue&type=script&lang=js"
import style0 from "./create-v2.vue?vue&type=style&index=0&id=4e82523f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e82523f",
  null
  
)

export default component.exports